"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriviaAppealCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../../..");
const TriviaAppealCard = (trivia) => {
    const card = __1.CardHelper.newCard();
    card.addItem((0, __1.AppealTitleWithManagementMenu)(trivia));
    if (trivia.description) {
        card.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: `Trivia: ${trivia.description}`,
            spacing: adaptivecards_1.Spacing.Medium,
            wrap: true,
        }));
    }
    if (trivia.state === "open") {
        card.addAction(__1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: "Play Trivia!",
            isPrimary: true,
            data: (0, __1.takingStartCommand)(trivia.id).toTaskFetchCommand(),
        }));
    }
    return card;
};
exports.TriviaAppealCard = TriviaAppealCard;
//# sourceMappingURL=TriviaAppealCard.js.map